import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useForm } from 'react-hook-form';
import { useRef, useLayoutEffect } from 'react';
import FunnelProgress from './funnel-progress';
import FormStep from './form-step';
import { setConfig, updateConsents } from '@uswitch/rvuconsent';
import { timeout, useComponentTracking } from '@uswitch/ev-utils/component-events';
import whitelist from '../../../utils/form-whitelist';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var Form = function Form(props) {
  var _progressPhases$activ;

  var _props$schema = props.schema,
      _props$schema$steps = _props$schema.steps,
      steps = _props$schema$steps === void 0 ? [] : _props$schema$steps,
      action = _props$schema.action,
      method = _props$schema.method,
      formName = _props$schema.formName,
      formId = _props$schema.formId,
      defaultInputs = _props$schema.defaultInputs,
      _props$schema$showPro = _props$schema.showProgressBar,
      showProgressBar = _props$schema$showPro === void 0 ? false : _props$schema$showPro,
      _props$schema$withBac = _props$schema.withBackButton,
      withBackButton = _props$schema$withBac === void 0 ? false : _props$schema$withBac,
      _props$schema$variant = _props$schema.variant,
      variant = _props$schema$variant === void 0 ? 'default' : _props$schema$variant,
      _props$schema$disable = _props$schema.disableButtonUntilValid,
      disableButtonUntilValid = _props$schema$disable === void 0 ? false : _props$schema$disable,
      _props$schema$rvucons = _props$schema.rvuconsent,
      rvuconsent = _props$schema$rvucons === void 0 ? null : _props$schema$rvucons,
      apiPath = props.apiPath,
      clientId = props.clientId,
      brand = props.brand,
      submit = props.submit,
      formType = props.formType,
      addressLookup = props.addressLookup,
      activeIndex = props.activeIndex,
      goForward = props.goForward,
      goBack = props.goBack,
      goToFirst = props.goToFirst,
      goToLast = props.goToLast,
      goToPage = props.goToPage,
      goToUrl = props.goToUrl,
      _props$query = props.query,
      query = _props$query === void 0 ? {} : _props$query,
      completionState = props.completionState,
      updateCompletionState = props.updateCompletionState,
      editFromSummary = props.editFromSummary,
      _props$trackInteracti = props.trackInteraction,
      trackInteraction = _props$trackInteracti === void 0 ? function () {} : _props$trackInteracti,
      segmentTracking = props.segmentTracking;
  var numberFormattedQuery = Object.entries(query).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        val = _ref2[1];

    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, !isNaN(parseInt(val, 10)) ? new Intl.NumberFormat('en-GB').format(val) : val));
  }, {});

  var _useForm = useForm({
    mode: 'all',
    defaultValues: _objectSpread(_objectSpread({}, defaultInputs), numberFormattedQuery)
  }),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      errors = _useForm.errors,
      setValue = _useForm.setValue,
      triggerValidation = _useForm.triggerValidation,
      formState = _useForm.formState,
      watch = _useForm.watch,
      getValues = _useForm.getValues;

  var form = useRef(null);
  var isDirty = formState.isDirty,
      isValid = formState.isValid;
  var trackComponent = useComponentTracking();

  var trackAndSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(data) {
      var submitForm;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              trackInteraction('GA Form Submitted', 'Form Interaction', "".concat(activeIndex));
              _context3.next = 3;
              return timeout(trackComponent('Form Event', 'formSubmitted', _objectSpread({
                formName: formName,
                formId: formId
              }, whitelist(data, steps))));

            case 3:
              submitForm = /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!segmentTracking) {
                            _context.next = 3;
                            break;
                          }

                          _context.next = 3;
                          return segmentTracking();

                        case 3:
                          return _context.abrupt("return", submit ? submit(data) : form.current.submit());

                        case 4:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function submitForm(_x2) {
                  return _ref4.apply(this, arguments);
                };
              }();

              if (rvuconsent) {
                _context3.next = 6;
                break;
              }

              return _context3.abrupt("return", submitForm(data));

            case 6:
              Promise.all(steps.reduce(function (acc, it) {
                return acc.concat(it.fields);
              }, []).map( /*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(field) {
                  var noConsent;
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          if (field.consentName) {
                            _context2.next = 2;
                            break;
                          }

                          return _context2.abrupt("return");

                        case 2:
                          if (!(!data["".concat(field.name, "-checkbox")] && !field.optionalConsent)) {
                            _context2.next = 4;
                            break;
                          }

                          return _context2.abrupt("return");

                        case 4:
                          noConsent = !data["".concat(field.name, "-checkbox")];
                          return _context2.abrupt("return", updateConsents({
                            email: data[field.name],
                            consents: noConsent ? [] : [{
                              name: field.consentName,
                              status: data["".concat(field.name, "-checkbox")],
                              source: rvuconsent.source,
                              sourceUrl: window.location.href
                            }]
                          }));

                        case 6:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x3) {
                  return _ref5.apply(this, arguments);
                };
              }())).then(function (_) {
                return submitForm(data);
              });

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function trackAndSubmit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var progressPhases = steps.reduce(function (acc, _ref6) {
    var id = _ref6.id,
        _ref6$funnelTitle = _ref6.funnelTitle,
        funnelTitle = _ref6$funnelTitle === void 0 ? '' : _ref6$funnelTitle;
    return [].concat(_toConsumableArray(acc), [{
      key: id,
      title: funnelTitle
    }]);
  }, []);
  var progressIncrement = Math.round(100 / steps.length); // set it globally before render so you can access it elsewhere

  useLayoutEffect(function () {
    if (rvuconsent) {
      setConfig({
        apiPath: apiPath,
        clientId: clientId,
        brand: brand
      });
    }
  }, []);
  return _jsxs("form", {
    name: "multi-step-".concat(formName),
    action: action,
    method: method,
    onSubmit: handleSubmit(trackAndSubmit),
    ref: form,
    sx: {
      variant: "elements.form.variants.".concat(variant, ".formWrapper")
    },
    id: formId,
    children: [showProgressBar ? _jsx("div", {
      sx: {
        variant: "elements.form.variants.".concat(variant, ".funnel"),
        mb: withBackButton && activeIndex !== 0 ? '0' : 'md'
      },
      children: _jsx(FunnelProgress, {
        phases: progressPhases,
        currentPhaseKey: ((_progressPhases$activ = progressPhases[activeIndex]) === null || _progressPhases$activ === void 0 ? void 0 : _progressPhases$activ.key) || '',
        progress: progressIncrement * activeIndex / 100,
        variant: "percentage"
      })
    }) : null, steps.map(function (step, i) {
      return _jsx(FormStep, _objectSpread({
        stepIndex: i,
        step: step,
        register: register,
        errors: errors,
        disableButtonUntilValid: disableButtonUntilValid,
        setValue: setValue,
        triggerValidation: triggerValidation,
        formType: formType,
        activeIndex: activeIndex,
        goForward: goForward,
        goBack: goBack,
        goToFirst: goToFirst,
        goToLast: goToLast,
        goToPage: goToPage,
        goToUrl: goToUrl,
        isDirty: isDirty,
        isValid: isValid,
        watch: watch,
        completionState: completionState,
        updateCompletionState: updateCompletionState,
        getValues: getValues,
        editFromSummary: editFromSummary,
        withBackButton: withBackButton,
        variant: variant,
        query: query,
        handleSubmit: handleSubmit,
        trackAndSubmit: trackAndSubmit,
        addressLookup: addressLookup
      }, props), i);
    })]
  });
};

export default Form;
//# sourceMappingURL=form.js.map